if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButtonwrap = this.querySelector('.product-form__buttons');
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);
      
      let Geschenkgutscheine = $('.product_Geschenkgutscheine').length;      
      if(Geschenkgutscheine > 0) {
         $('.cart-error-text').text('');
         var Geschenkgutscheine_val = $('.product_Geschenkgutscheine .field__input').val();
         if(Geschenkgutscheine_val){ } else {
            $('.cart-error-text').text('Bitte ergänzen Sie Name des Beschenkten.');
            return false;
         }            
      }
      
      var hidden_product = $('.active-product').find('.hidden_product_input').length;  
      //console.log(hidden_product);
      if(hidden_product > 0) {
      if ($('.active-product').find('input[name="Individuell"]').is(':checked')) {
        var individuell_no =$('.active-product').find('#individuell-nummer').val();
        var individuell_name =$('.active-product').find('#individuell-name').val();
        
        if(individuell_no && individuell_name){    
         var individuelle = +individuell_no+" "+ individuell_name;
         $('.active-product').find('.cart-error-text').text('');         
        } else if (individuell_no == '' && individuell_name == '') {
         $('.active-product').find('.cart-error-text').text('Bitte ergänzen Sie Nr. & Name für Individuell.');
         return false;
        } else if (individuell_no == '' && individuell_name) {
         $('.active-product').find('.cart-error-text').text('Bitte ergänzen Sie Nr. für Individuell.');
         return false;
        } else if (individuell_no && individuell_name == '') {
         $('.active-product').find('.cart-error-text').text('Bitte ergänzen Sie Name für Individuell.');
         return false;
        }         
      }      
      }

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
     
      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;     
      
      if(hidden_product > 0) {
        
      var $quantity = $('.active-product').find(".quantity__input").val();
      var $product_main =$('.active-product').find('#product-form-installment').find('[name=id]').val();  

            
      var purchase_code =$('.active-product').find('#input-purchase-code').val();
      let random_no = Math.floor(Math.random() * 100000000);  
        
      if(hidden_product == 1) {
        if ($('.active-product').find("#hidden_product_1").hasClass("product-form__input--dropdown")) {
           var $product_hidden_1 =$('.active-product').find('#hidden_product_1').find(':selected').data('variantid');
        } else {
           var $product_hidden_1 =$('.active-product').find('#hidden_product_1').find('input:checked').data('variantid');
        }

        /* 0 products */
        if($product_hidden_1 == undefined){
        var items = [  
        { quantity: $quantity, id: $product_main, properties: { 'TRIKOT': random_no, 'purchase-code': purchase_code } }
        ];        
        var data = { items: items };
        }
        
        /* 1 products */
        if($product_hidden_1){ 
          var items = [       
            { quantity: $quantity, id: $product_hidden_1, properties: { 'TRIKOT': random_no, 'Individuell': individuelle } },       
            { quantity: $quantity, id: $product_main, properties: { 'TRIKOT': random_no, 'purchase-code': purchase_code } }
           ];          
          var data = { items: items };
        } 
      }
        
      if(hidden_product == 2) {
        if ($('.active-product').find("#hidden_product_1").hasClass("product-form__input--dropdown")) {
           var $product_hidden_1 =$('.active-product').find('#hidden_product_1').find(':selected').data('variantid');
        } else {
           var $product_hidden_1 =$('.active-product').find('#hidden_product_1').find('input:checked').data('variantid');
        }
        
        if ($('.active-product').find("#hidden_product_2").hasClass("product-form__input--dropdown")) {
        var $product_hidden_2 =$('.active-product').find('#hidden_product_2').find(':selected').data('variantid');
        } else {
        var $product_hidden_2 =$('.active-product').find('#hidden_product_2').find('input:checked').data('variantid');
        }
        
        var product_hidden_list = [[0,$product_hidden_1],[1,$product_hidden_2]];
        let count_p = 0;
        var product_hidden_1_final = '';
        var product_hidden_2_final = '';       
        var position = [];        
        for(let p=0; p < product_hidden_list.length ;p++){               
          if(product_hidden_list[p][1] != undefined){
            count_p = count_p + 1;  
            position.push(p);
          }          
        }

        /* 0 products */
        if($product_hidden_1 == undefined && $product_hidden_2 == undefined){
        var items = [  
        { quantity: $quantity, id: $product_main, properties: { 'TRIKOT': random_no, 'purchase-code': purchase_code } }
        ];        
        var data = { items: items };
        } 
        
        /* 1 products */        
        if(count_p == 1){
            product_hidden_1_final = product_hidden_list[position[0]][1];
            var items = [       
            { quantity: $quantity, id: product_hidden_1_final, properties: { 'TRIKOT': random_no, 'Individuell': individuelle } },              
            { quantity: $quantity, id: $product_main, properties: {  'TRIKOT': random_no, 'purchase-code': purchase_code } }
            ];           
            var data = { items: items };
        } 
        
        /* 2 products */
        if(count_p == 2){
          product_hidden_1_final = product_hidden_list[position[0]][1];
          product_hidden_2_final = product_hidden_list[position[1]][1];
          
          var items = [       
            { quantity: $quantity, id: product_hidden_1_final, properties: { 'TRIKOT': random_no, 'Individuell': individuelle } },
            { quantity: $quantity, id: product_hidden_2_final, properties: { 'TRIKOT': random_no, 'Individuell': individuelle } },
            { quantity: $quantity, id: $product_main, properties: {  'TRIKOT': random_no, 'purchase-code': purchase_code } }
            ];           
            var data = { items: items };
        } 
        
      } 
        
      if(hidden_product == 3) {
        if ($('.active-product').find("#hidden_product_1").hasClass("product-form__input--dropdown")) {
           var $product_hidden_1 =$('.active-product').find('#hidden_product_1').find(':selected').data('variantid');
        } else {
           var $product_hidden_1 =$('.active-product').find('#hidden_product_1').find('input:checked').data('variantid');
        }
        
        if ($('.active-product').find("#hidden_product_2").hasClass("product-form__input--dropdown")) {
        var $product_hidden_2 =$('.active-product').find('#hidden_product_2').find(':selected').data('variantid');
        } else {
        var $product_hidden_2 =$('.active-product').find('#hidden_product_2').find('input:checked').data('variantid');
        }
        
        if ($('.active-product').find("#hidden_product_3").hasClass("product-form__input--dropdown")) {
        var $product_hidden_3 =$('.active-product').find('#hidden_product_3').find(':selected').data('variantid');
        } else {
        var $product_hidden_3 =$('.active-product').find('#hidden_product_3').find('input:checked').data('variantid');
        }

        var product_hidden_list = [[0,$product_hidden_1],[1,$product_hidden_2],[2,$product_hidden_3]];
        let count_p = 0;
        var product_hidden_1_final = '';
        var product_hidden_2_final = ''; 
        var product_hidden_3_final = '';
        var position = [];        
        for(let p=0; p < product_hidden_list.length ;p++){               
          if(product_hidden_list[p][1] != undefined){
            count_p = count_p + 1;  
            position.push(p);
          }          
        }

        /* 0 products */
        if($product_hidden_1 == undefined && $product_hidden_2 == undefined && $product_hidden_3 == undefined){
        var items = [  
        { quantity: $quantity, id: $product_main, properties: { 'TRIKOT': random_no, 'purchase-code': purchase_code } }
        ];        
        var data = { items: items };
        }

        /* 1 products */        
        if(count_p == 1){
            product_hidden_1_final = product_hidden_list[position[0]][1];
            var items = [       
            { quantity: $quantity, id: product_hidden_1_final, properties: { 'TRIKOT': random_no, 'Individuell': individuelle } },              
            { quantity: $quantity, id: $product_main, properties: {  'TRIKOT': random_no, 'purchase-code': purchase_code } }
            ];           
            var data = { items: items };
        } 
        
        /* 2 products */
        if(count_p == 2){
          product_hidden_1_final = product_hidden_list[position[0]][1];
          product_hidden_2_final = product_hidden_list[position[1]][1];
          
          var items = [       
            { quantity: $quantity, id: product_hidden_1_final, properties: { 'TRIKOT': random_no, 'Individuell': individuelle } },
            { quantity: $quantity, id: product_hidden_2_final, properties: { 'TRIKOT': random_no, 'Individuell': individuelle } },
            { quantity: $quantity, id: $product_main, properties: {  'TRIKOT': random_no, 'purchase-code': purchase_code } }
            ];           
            var data = { items: items };
        }

        /* 3 products */
        if(count_p == 3){
          product_hidden_1_final = product_hidden_list[position[0]][1];
          product_hidden_2_final = product_hidden_list[position[1]][1];
          product_hidden_3_final = product_hidden_list[position[2]][1];
          
          var items = [       
            { quantity: $quantity, id: product_hidden_1_final, properties: { 'TRIKOT': random_no, 'Individuell': individuelle } },
            { quantity: $quantity, id: product_hidden_2_final, properties: { 'TRIKOT': random_no, 'Individuell': individuelle } },
            { quantity: $quantity, id: product_hidden_3_final, properties: { 'TRIKOT': random_no, 'Individuell': individuelle } },
            { quantity: $quantity, id: $product_main, properties: {  'TRIKOT': random_no, 'purchase-code': purchase_code } }
            ];           
            var data = { items: items };
        }
        
      }
        
      if(hidden_product == 4) {
        if ($('.active-product').find("#hidden_product_1").hasClass("product-form__input--dropdown")) {
           var $product_hidden_1 =$('.active-product').find('#hidden_product_1').find(':selected').data('variantid');
        } else {
           var $product_hidden_1 =$('.active-product').find('#hidden_product_1').find('input:checked').data('variantid');
        }
        
        if ($('.active-product').find("#hidden_product_2").hasClass("product-form__input--dropdown")) {
        var $product_hidden_2 =$('.active-product').find('#hidden_product_2').find(':selected').data('variantid');
        } else {
        var $product_hidden_2 =$('.active-product').find('#hidden_product_2').find('input:checked').data('variantid');
        }
        
        if ($('.active-product').find("#hidden_product_3").hasClass("product-form__input--dropdown")) {
        var $product_hidden_3 =$('.active-product').find('#hidden_product_3').find(':selected').data('variantid');
        } else {
        var $product_hidden_3 =$('.active-product').find('#hidden_product_3').find('input:checked').data('variantid');
        }
        
        if ($('.active-product').find("#hidden_product_4").hasClass("product-form__input--dropdown")) {
        var $product_hidden_4 =$('.active-product').find('#hidden_product_4').find(':selected').data('variantid');
        } else {
        var $product_hidden_4 =$('.active-product').find('#hidden_product_4').find('input:checked').data('variantid'); 
        }
        console.log($product_hidden_1,$product_hidden_2,$product_hidden_3,$product_hidden_4);
        
        let count_p = 0;
        var product_hidden_list = [[0,$product_hidden_1],[1,$product_hidden_2],[2,$product_hidden_3],[3,$product_hidden_4]];        
        var product_hidden_1_final = '';
        var product_hidden_2_final = '';
        var product_hidden_3_final = '';
        var product_hidden_4_final = '';
        var position = [];        
        for(let p=0; p < product_hidden_list.length ;p++){               
          if(product_hidden_list[p][1] != undefined){
            count_p = count_p + 1;  
            position.push(p);
          }          
        }
        
        /* 0 products */
         if(count_p == 0){
          var items = [  
          { quantity: $quantity, id: $product_main, properties: { 'TRIKOT': random_no, 'purchase-code': purchase_code } }
         ];          
         var data = { items: items };
        }
        
        /* 1 products */        
        if(count_p == 1){
            product_hidden_1_final = product_hidden_list[position[0]][1];
            var items = [       
            { quantity: $quantity, id: product_hidden_1_final, properties: { 'TRIKOT': random_no, 'Individuell': individuelle } },              
            { quantity: $quantity, id: $product_main, properties: {  'TRIKOT': random_no, 'purchase-code': purchase_code } }
            ];           
            var data = { items: items };
        }
        
        /* 2 products */
        if(count_p == 2){
            product_hidden_1_final = product_hidden_list[position[0]][1];
            product_hidden_2_final = product_hidden_list[position[1]][1];
          
            var items = [       
            { quantity: $quantity, id: product_hidden_1_final, properties: { 'TRIKOT': random_no, 'Individuell': individuelle } },
            { quantity: $quantity, id: product_hidden_2_final, properties: { 'TRIKOT': random_no, 'Individuell': individuelle } },
            { quantity: $quantity, id: $product_main, properties: {  'TRIKOT': random_no, 'purchase-code': purchase_code } }
            ];           
            var data = { items: items };
        }
              
        /* 3 products */
        if(count_p == 3){
            product_hidden_1_final = product_hidden_list[position[0]][1];
            product_hidden_2_final = product_hidden_list[position[1]][1];
            product_hidden_3_final = product_hidden_list[position[2]][1];
          
            var items = [       
            { quantity: $quantity, id: product_hidden_1_final, properties: { 'TRIKOT': random_no, 'Individuell': individuelle } },
            { quantity: $quantity, id: product_hidden_2_final, properties: { 'TRIKOT': random_no, 'Individuell': individuelle } },
            { quantity: $quantity, id: product_hidden_3_final, properties: { 'TRIKOT': random_no, 'Individuell': individuelle } },
            { quantity: $quantity, id: $product_main, properties: {  'TRIKOT': random_no, 'purchase-code': purchase_code } }
            ];           
            var data = { items: items };
        }  

        /* 4 products */
        if(count_p == 4){
            product_hidden_1_final = product_hidden_list[position[0]][1];
            product_hidden_2_final = product_hidden_list[position[1]][1];
            product_hidden_3_final = product_hidden_list[position[2]][1];
            product_hidden_4_final = product_hidden_list[position[3]][1];
          
            var items = [       
            { quantity: $quantity, id: product_hidden_1_final, properties: { 'TRIKOT': random_no, 'Individuell': individuelle } },
            { quantity: $quantity, id: product_hidden_2_final, properties: { 'TRIKOT': random_no, 'Individuell': individuelle } },
            { quantity: $quantity, id: product_hidden_3_final, properties: { 'TRIKOT': random_no, 'Individuell': individuelle } },
            { quantity: $quantity, id: product_hidden_4_final, properties: { 'TRIKOT': random_no, 'Individuell': individuelle } },
            { quantity: $quantity, id: $product_main, properties: {  'TRIKOT': random_no, 'purchase-code': purchase_code } }
            ];           
            var data = { items: items };
        }
        
      }
        
      if(hidden_product == 5) {
        if ($('.active-product').find("#hidden_product_1").hasClass("product-form__input--dropdown")) {
           var $product_hidden_1 =$('.active-product').find('#hidden_product_1').find(':selected').data('variantid');
        } else {
           var $product_hidden_1 =$('.active-product').find('#hidden_product_1').find('input:checked').data('variantid');
        }
        
        if ($('.active-product').find("#hidden_product_2").hasClass("product-form__input--dropdown")) {
        var $product_hidden_2 =$('.active-product').find('#hidden_product_2').find(':selected').data('variantid');
        } else {
        var $product_hidden_2 =$('.active-product').find('#hidden_product_2').find('input:checked').data('variantid');
        }
        
        if ($('.active-product').find("#hidden_product_3").hasClass("product-form__input--dropdown")) {
        var $product_hidden_3 =$('.active-product').find('#hidden_product_3').find(':selected').data('variantid');
        } else {
        var $product_hidden_3 =$('.active-product').find('#hidden_product_3').find('input:checked').data('variantid');
        }
        
        if ($('.active-product').find("#hidden_product_4").hasClass("product-form__input--dropdown")) {
        var $product_hidden_4 =$('.active-product').find('#hidden_product_4').find(':selected').data('variantid');
        } else {
        var $product_hidden_4 =$('.active-product').find('#hidden_product_4').find('input:checked').data('variantid'); 
        }
        
        if ($('.active-product').find("#hidden_product_5").hasClass("product-form__input--dropdown")) {
        var $product_hidden_5 =$('.active-product').find('#hidden_product_5').find(':selected').data('variantid');
        } else {
        var $product_hidden_5 =$('.active-product').find('#hidden_product_5').find('input:checked').data('variantid'); 
        }        
        console.log($product_hidden_1,$product_hidden_2,$product_hidden_3,$product_hidden_4,$product_hidden_5);

        let count_p = 0;
        var product_hidden_list = [[0,$product_hidden_1],[1,$product_hidden_2],[2,$product_hidden_3],[3,$product_hidden_4],[4,$product_hidden_5]];        
        var product_hidden_1_final = '';
        var product_hidden_2_final = '';
        var product_hidden_3_final = '';
        var product_hidden_4_final = '';
        var product_hidden_5_final = '';
        var position = [];        
        for(let p=0; p < product_hidden_list.length ;p++){               
          if(product_hidden_list[p][1] != undefined){
            count_p = count_p + 1;  
            position.push(p);
          }          
        }
        
        /* 0 products */
        if($product_hidden_1 == undefined && $product_hidden_2 == undefined && $product_hidden_3 == undefined && $product_hidden_4 == undefined && $product_hidden_5 == undefined){
        var items = [  
        { quantity: $quantity, id: $product_main, properties: { 'TRIKOT': random_no, 'purchase-code': purchase_code } }
        ];        
        var data = { items: items };
        }

        /* 1 products */        
        if(count_p == 1){
            product_hidden_1_final = product_hidden_list[position[0]][1];
            var items = [       
            { quantity: $quantity, id: product_hidden_1_final, properties: { 'TRIKOT': random_no, 'Individuell': individuelle } },              
            { quantity: $quantity, id: $product_main, properties: {  'TRIKOT': random_no, 'purchase-code': purchase_code } }
            ];           
            var data = { items: items };
        }
        
        /* 2 products */
        if(count_p == 2){
            product_hidden_1_final = product_hidden_list[position[0]][1];
            product_hidden_2_final = product_hidden_list[position[1]][1];
          
            var items = [       
            { quantity: $quantity, id: product_hidden_1_final, properties: { 'TRIKOT': random_no, 'Individuell': individuelle } },
            { quantity: $quantity, id: product_hidden_2_final, properties: { 'TRIKOT': random_no, 'Individuell': individuelle } },
            { quantity: $quantity, id: $product_main, properties: {  'TRIKOT': random_no, 'purchase-code': purchase_code } }
            ];           
            var data = { items: items };
        }
              
        /* 3 products */
        if(count_p == 3){
            product_hidden_1_final = product_hidden_list[position[0]][1];
            product_hidden_2_final = product_hidden_list[position[1]][1];
            product_hidden_3_final = product_hidden_list[position[2]][1];
          
            var items = [       
            { quantity: $quantity, id: product_hidden_1_final, properties: { 'TRIKOT': random_no, 'Individuell': individuelle } },
            { quantity: $quantity, id: product_hidden_2_final, properties: { 'TRIKOT': random_no, 'Individuell': individuelle } },
            { quantity: $quantity, id: product_hidden_3_final, properties: { 'TRIKOT': random_no, 'Individuell': individuelle } },
            { quantity: $quantity, id: $product_main, properties: {  'TRIKOT': random_no, 'purchase-code': purchase_code } }
            ];           
            var data = { items: items };
        }  

        /* 4 products */
        if(count_p == 4){
            product_hidden_1_final = product_hidden_list[position[0]][1];
            product_hidden_2_final = product_hidden_list[position[1]][1];
            product_hidden_3_final = product_hidden_list[position[2]][1];
            product_hidden_4_final = product_hidden_list[position[3]][1];
          
            var items = [       
            { quantity: $quantity, id: product_hidden_1_final, properties: { 'TRIKOT': random_no, 'Individuell': individuelle } },
            { quantity: $quantity, id: product_hidden_2_final, properties: { 'TRIKOT': random_no, 'Individuell': individuelle } },
            { quantity: $quantity, id: product_hidden_3_final, properties: { 'TRIKOT': random_no, 'Individuell': individuelle } },
            { quantity: $quantity, id: product_hidden_4_final, properties: { 'TRIKOT': random_no, 'Individuell': individuelle } },
            { quantity: $quantity, id: $product_main, properties: {  'TRIKOT': random_no, 'purchase-code': purchase_code } }
            ];           
            var data = { items: items };
        }
        
        /* 5 products */           
        if(count_p == 5){
            product_hidden_1_final = product_hidden_list[position[0]][1];
            product_hidden_2_final = product_hidden_list[position[1]][1];
            product_hidden_3_final = product_hidden_list[position[2]][1];
            product_hidden_4_final = product_hidden_list[position[3]][1];
            product_hidden_5_final = product_hidden_list[position[4]][1];
          
            var items = [       
            { quantity: $quantity, id: product_hidden_1_final, properties: { 'TRIKOT': random_no, 'Individuell': individuelle } },
            { quantity: $quantity, id: product_hidden_2_final, properties: { 'TRIKOT': random_no, 'Individuell': individuelle } },
            { quantity: $quantity, id: product_hidden_3_final, properties: { 'TRIKOT': random_no, 'Individuell': individuelle } },
            { quantity: $quantity, id: product_hidden_4_final, properties: { 'TRIKOT': random_no, 'Individuell': individuelle } },
            { quantity: $quantity, id: product_hidden_5_final, properties: { 'TRIKOT': random_no, 'Individuell': individuelle } },
            { quantity: $quantity, id: $product_main, properties: {  'TRIKOT': random_no, 'purchase-code': purchase_code } }
            ];           
            var data = { items: items };
        }


      }   
      
      console.log(data, hidden_product);     
             
        $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: data,
        beforeSend: function() {
          $('.cart-error-text').html('');
        },
        success: function(itemData) { 
         window.location.href = '/cart';       
        },
        error: function(XMLHttpRequest) {
          var response = eval('(' + XMLHttpRequest.responseText + ')');
          response = response.description;
          $('.cart-error-text').html(response);
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          submitButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
        }
      });
      
      return false;
      }


      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartNotification.renderContents(response);
          
          if(response.sku == '98821654570'){
            submitButton.classList.add('product_exist');
          }
          
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          submitButtonwrap.classList.add('success');
          
          setTimeout(() => {
            submitButtonwrap.classList.remove('success');
      }, 4000); 
  
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
